import { useRouter } from 'next/router';

import { Box, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import { UniversityHistoryContainer, UniversityHistory, ImageWrapperUniversityHistory } from './style';

import Image from '@components/atoms/image';
import { useUniversityInformation } from '@helpers/use';
import { getAssetUrl, sanitize } from '@helpers/utils';

export const UniversityHistorySection = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const universityIdName = router.query.universityIdName as string;
  const { landingPage } = useUniversityInformation(universityIdName);

  return (
    <UniversityHistoryContainer>
      <UniversityHistory>
        <Box flex={1}>
          <Typography fontSize="24px" lineHeight="24px" fontWeight={500} marginBottom={1} color="#00000099">
            {t('academic_landing_page.university_history_section.heading')}
          </Typography>
          <Typography fontSize="30px" lineHeight="34px" fontWeight={700} marginBottom={2} color="#000000de">
            {landingPage?.historySectionHeading}
          </Typography>
          <Typography variant="body2_deprecated" color="#00000099">
            <div
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={sanitize(landingPage?.historyDescription || '')}
            />
          </Typography>
        </Box>
        <ImageWrapperUniversityHistory>
          <Image src={landingPage?.historyImageUrl || ''} alt="University History" />
        </ImageWrapperUniversityHistory>
      </UniversityHistory>
    </UniversityHistoryContainer>
  );
};
